import React, { Component } from 'react';
import { connect } from 'react-redux'
import { formatDetectionDatetime } from '../utilities/datetime'
import { getCityLookupData, getCountryLookupData, getIndustryLookupData, getLookupData, getStateLookupData } from '../store/entities/lookup'

import backButton from '../assets/backButton.svg'
import screenshotSvg from '../assets/screenshot.svg'
import htmlSvg from '../assets/html.svg'
import screenshotSelectedSvg from '../assets/screenshot_selected.svg'
import htmlSelectedSvg from '../assets/html_selected.svg'
import './incidentDetails.scss'
import UpdatePopover from './common/popover/updatePopover'
import LoaderWrapper from './common/LoaderWrapper/LoaderWrapper'
import AceEditor from "react-ace";

import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/ext-language_tools";
import "ace-builds/src-noconflict/theme-solarized_light"
import { loadThreatIntelById } from '../store/entities/threatintel';
class ThreatIntelDetails extends Component {
      state = {
        pageContent: '',
        selectedTab: 1,
        defaultModelCode: "PP1",
        context: this.props.location && this.props.location.state ? this.props.location.state.context : 'threat-intel-feed'
      }
    
      componentDidMount() {
        this.props.loadThreatIntelById(this.props.match.params.id, this.props.selectedCustomer ? this.props.selectedCustomer?.id : null);
        this.props.getIndustryLookupData();
        
      }
    
      handleReturn = () => {
        const { context } = this.state

        switch(context) {
          case 'threat-intel-feed':
            this.props.history.push(`/threat-intel-feed/`)
            break;
          case 'threat-intel':
            this.props.history.push(`/threat-intel/`, { selectedNavItem: 'Portal'})
            break;
          default:
            this.props.history.push(`/threat-intel-feed/`)
        }
      }
    
      componentDidUpdate(prevProps) {
          if(this.props.selectedEvent && prevProps.selectedEvent !== this.props.selectedEvent) {
            this.props.getCountryLookupData();
            if(this.props.selectedEvent.country){
              this.props.getStateLookupData(this.props.selectedEvent.country);
            }
            if(this.props.selectedEvent.state && this.props.selectedEvent.country){
              this.props.getCityLookupData(this.props.selectedEvent.state, this.props.selectedEvent.country);
            }
          }
      }

      getIndustryFromLookup = (industryId) => {
        const { industriesLookup } = this.props;
        if (industriesLookup && industriesLookup.length > 0) {
          const industry = industriesLookup.find(ind => ind.code === industryId);
          return industry ? industry.value : 'NA';
        }
        return 'NA';
      }

      getCountryFromLookup = (countryCode) => {
        const { countryLookup } = this.props;
        if (countryLookup && countryLookup.length > 0) {
          const country = countryLookup.find(country => country.code === countryCode);
          return country ? country.value : 'NA';
        }
        return 'NA';
      }

      getStateFromLookup = (stateCode) => {
        const { stateLookup } = this.props; 
        if (stateLookup && stateLookup.length > 0) {
          const state = stateLookup.find(state => state.code === stateCode);
          return state ? state.value : 'NA';
        }
        return 'NA';
      }

      getCityFromLookup = (cityId) => {
        const { cityLookup } = this.props;
        if (cityLookup && cityLookup.length > 0) {
          const city = cityLookup.find(city => city.code === cityId);
          return city ? city.value : 'NA';
        }
        return 'NA';
      }


    
      render() {
        const { selectedTab, context} = this.state
        const {selectedEvent , selectedEventLoading } = this.props
        const showUpdatePopover = context === "threat-intel-feed" && this.props.tokenRoles === 'PixmAdmin';
        const screenshotPlaceholder = `${process.env.REACT_APP_EXTERNAL_PAGES_BASE_URL}/placeholders/screenshot.jpeg`;
        return (
          <>
            {(
              <div className="pageContainer">
               <LoaderWrapper loading={selectedEventLoading} data={selectedEvent} styles={{ minHeight: '500px' }} placeholderText={"No Data Found"} waitForData={true}>
                <div className="wrapper">
                  <div className="sections actionBar">
                    <div className="pointer" onClick={this.handleReturn}>
                      <img width="25px" src={backButton} alt="" srcSet="" />
                      <span>Return to Overview</span>
                    </div>

                    {  showUpdatePopover && <UpdatePopover
                      {...this.props}
                      role={this.props.tokenRoles}
                      event={selectedEvent}
                      from="ThreatIntelDetails"
                    />} 
                  </div>
                  
                  <div className="sections details">
                    <div className="tableView">
                      <table id="detailsTable">
                        <tbody>
                          <tr>
                            <td>Opened</td>
                            <td>
                              {formatDetectionDatetime(selectedEvent.threatDetectedOn)}
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={2}>
                              <b>Threat Details :</b>
                            </td>
                          </tr>
                          <tr>
                            <td>Brand</td>
                            <td>
                              <b>{selectedEvent.detectedBrands ? selectedEvent.detectedBrands : 'NA'}</b>
                            </td>
                          </tr>
                          <tr>
                            <td>Status</td>
                            <td className={selectedEvent.isVerified === "Y" ? "pixmVerifiedText" : "unverifiedText"}>
                              <b>{selectedEvent.isVerified === "Y" ? "Pixm Verified" : 'AI Suspicious'}</b>
                            </td>
                          </tr>
                          <tr>
                            <td>IP</td>
                            <td>{selectedEvent.threatIPAddress || 'NA'}</td>
                          </tr>
                          <tr>
                            <td>Url</td>
                            <td>
                              <span>{selectedEvent.threatURL}</span>
                            </td>
                          </tr>
                           <tr>
                            <td>Industry</td>
                            <td>
                              <span>{this.getIndustryFromLookup(selectedEvent.industry)}</span>
                            </td>
                          </tr>
                          <tr>
                            <td>Country</td>
                            <td>
                              <span>{this.getCountryFromLookup(selectedEvent.country) || "NA"}</span>
                            </td>
                          </tr>
                          <tr>
                            <td>State</td>
                            <td>
                              <span>{this.getStateFromLookup(selectedEvent.state) || "NA"}</span>
                            </td>
                          </tr>
                          <tr>
                            <td>City</td>
                            <td>
                              <span>{this.getCityFromLookup(selectedEvent.city) || "NA"}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="divider"></div>
                  <div className="tabView">
                  <div className="tabs pointer">
                    <div
                      className="tab rightLine"
                      onClick={() => this.setState({ selectedTab: 1 })}
                    >
                      <img
                        src={
                          selectedTab === 1
                            ? screenshotSelectedSvg
                            : screenshotSvg
                        }
                        width="25px"
                      />
                      <span style={{ color: selectedTab === 1 && '#2d5fa7' }}>
                        Screenshot
                      </span>
                    </div>
                    <div
                      className="tab rightLine"
                      onClick={() => this.setState({ selectedTab: 2 })}
                    >
                      <img
                        src={selectedTab === 2 ? htmlSelectedSvg : htmlSvg}
                        width="25px"
                      />
                      <span style={{ color: selectedTab === 2 && '#2d5fa7' }}>
                        HTML
                      </span>
                    </div>
                  </div>
                  <div className="dataView">
                    {selectedTab === 1 && (
                      <div className="imageContainer">
                        <img
                          src={selectedEvent.screenshot || screenshotPlaceholder }
                          className={'dataImg'}
                        />
                      </div>
                    )}
                    {selectedTab === 2 && (
                      <div className="codeblock">
                        <AceEditor
                          placeholder="This is a placeholder html template"
                          height='100%'
                          width='100%'
                          mode="html"
                          theme="solarized_light"
                          name="html_content"
                          fontSize={16}
                          lineHeight={20}
                          showPrintMargin={true}  
                          showGutter={true}
                          highlightActiveLine={true}
                          value={selectedEvent.html || 'HTML not available'}
                          readOnly={true}
                          setOptions={{
                          enableBasicAutocompletion: false,
                          enableLiveAutocompletion: false,
                          enableSnippets: false,
                          showLineNumbers: true,
                          tabSize: 2,
                          }}/>
                      </div>
                    )}
                   
                  </div>
                </div>
                  </div>
                </div>
              </LoaderWrapper>
              </div>
            )}
          </>
        )
      }
}

const mapStateToProps = (state) => ({
    selectedEvent: state.entities.threatintel.selectedEvent,
    selectedEventLoading: state.entities.threatintel.selectedEventLoading,
    selectedCustomer : state.entities.customers.selected,
    lookupLoading: state.entities.lookup.loading,
    industriesLookup: state.entities.lookup.industries,
    countryLookup: state.entities.lookup.countries,
    stateLookup: state.entities.lookup.states,
    cityLookup: state.entities.lookup.cities,
    tokenRoles: state.entities.user.roles,
})
const mapDispatchToProps = (dispatch) => ({
    loadThreatIntelById: (id, cid) => dispatch(loadThreatIntelById(id, cid)),
    getLookupData: (lookupType) => dispatch(getLookupData(lookupType)),
    getIndustryLookupData: () => dispatch(getIndustryLookupData()),
    getCountryLookupData: () => dispatch(getCountryLookupData()),
    getStateLookupData: (countryCode) => dispatch(getStateLookupData(countryCode)),
    getCityLookupData: (stateCode, countryCode) => dispatch(getCityLookupData(stateCode, countryCode)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ThreatIntelDetails);